import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-528fc8fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-datasource" }
const _hoisted_2 = { class: "news-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "news-list-item-left" }
const _hoisted_5 = { class: "news-list-item-tag" }
const _hoisted_6 = { class: "news-list-item-title" }
const _hoisted_7 = { class: "news-list-item-right" }
const _hoisted_8 = { class: "news-list-item-date" }
const _hoisted_9 = {
  key: 0,
  style: {"margin-top":"30px","margin-bottom":"10px","display":"flex","justify-content":"center"},
  class: "news-list-load-more"
}

import {computed, h, onMounted, PropType, ref, toRaw, unref, watch, watchEffect} from "vue";
import {UIHandleGet} from "@/views/utils";
import {useRouter} from "vue-router";
import {EmptyPage, Page, PageRequest} from "@/model/Page";
import NewsAPI from "@/api/NewsAPI";
import {News, NewsContentType} from "@/model/News";
import {formatTime} from "@/utils/filter";

interface QueryFrom extends PageRequest {
  sectionId?: string
}


const __default__ = {
  name: "AppConfigComponentDrawerNewsList"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  sectionId: {
    type: String,
    required: true
  },
},
  setup(__props) {

const props = __props



const numberPerRow = ref<number>(2)
const queryForm = ref<QueryFrom>({})
const loading = ref<boolean>(false)
// 是否加载到底部
const isEnd = ref<boolean>(false)

// 当前分页数据
const currentPageData = ref<Page<News>>(EmptyPage())
// 当前data
const data = computed(() => {
  return currentPageData.value?.list || []
})

// 是否无限加载
// const infiniteScroll = computed(() => {
//   return props.limitNumber === 0
// })

const nextPage = ref<number>(1)
const request = async () => {
  try {
    loading.value = true

    // 如果有限制数量展示，则使用限制的数量作为length,没有则代表需要分页展示所有数据，每页20条
    length = 8
    let rawQueryForm: any = {
      ...toRaw(unref(queryForm)),
      length: length,
      sectionId: props.sectionId
    }
    let result = await UIHandleGet(NewsAPI.page(rawQueryForm))
    isEnd.value = result.list!.length < length

    // 加载更多的模式则无限添加到数据后头
    // if (props.infiniteScrollWay === InfiniteScrollWay.CLICK) {
    result.list = currentPageData.value.list!.concat(result.list!)
    currentPageData.value = result
    // } else {
    //   currentPageData.value = result
    // }

  } catch (e) {
    console.error(e)
  } finally {
    loading.value = false
  }
}

const paddingNumber = computed(() => {
  if (data.value) {
    let length = data.value.length
    let paddingNumber = length % numberPerRow.value
    if (paddingNumber > 0) {
      return numberPerRow.value - paddingNumber
    }
  }
  return 0
})

// 加载更多
const loadMoreByClickWay = async () => {
  queryForm.value.page = currentPageData.value.page + 1
  await request()
}

const router = useRouter()
const goNewsDetailView = (news: News) => {
  let href: string | undefined
  if (news.contentType === NewsContentType.HTML) {
    href = router.resolve({
      path: `/news/${news.id}`
    }).href
  } else if (news.contentType === NewsContentType.LINK) {
    href = news.link
  }
  if (href) {
    window.open(href)
  }
}

onMounted(async () => {
  await request()
})



return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(data) && _unref(data).length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (news) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "news-list-item",
                onClick: _withModifiers(($event: any) => (goNewsDetailView(news)), ["stop"])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (news.tagName)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(news.tagName), 1),
                        _createVNode(_component_el_divider, {
                          direction: "vertical",
                          style: {"flex-shrink":"0","margin":"0 8px"}
                        })
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(news.title), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatTime)(news.publicationTime, 'YYYY-mm-dd')), 1)
                ])
              ], 8, _hoisted_3))
            }), 256)),
            (_unref(paddingNumber) > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(paddingNumber), (index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "news-list-item-placeholder",
                    style: _normalizeStyle({width: _ctx.withPercentage})
                  }, null, 4))
                }), 256))
              : _createCommentVNode("", true)
          ]),
          (!isEnd.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_el_button, {
                  onClick: loadMoreByClickWay,
                  loading: loading.value,
                  size: "default",
                  text: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("点击加载更多")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          "image-size": 50,
          description: "不好意思，没有发现任何数据哦～"
        }))
  ])), [
    [_directive_loading, currentPageData.value.page < 2 && loading.value]
  ])
}
}

})